import React, { useContext } from 'react'
import { LocalesContext } from '../../contexts/LocalesContext'
import ListItemComponent from '../../components/ListItemComponent'
import { formatValueWithUnit } from '../../utils/unitsConverter'

export default function SessionStatsComponent(props) {
  const { t } = useContext(LocalesContext)

  const isImperial = props.unitsSystem === 'imperial'

  const { statAverageSpeed, statSuperficieLavorata, statVariations, statSingulation, statDoubles, statSkips, statTotalTarget } = props.session.params
  
  return (
    <>
      <ListItemComponent title={t('VelocitaMedia')}>
        {statAverageSpeed ? formatValueWithUnit(statAverageSpeed, 'speed', isImperial) : ' - '}
      </ListItemComponent>
      <ListItemComponent title={t('SuperficieLavorata')}>
        {statSuperficieLavorata ? formatValueWithUnit(statSuperficieLavorata, 'area', isImperial) : ' - '}
      </ListItemComponent>
      <ListItemComponent title={t('DistanzaSemina')}>
        {statVariations ? formatValueWithUnit(statVariations, 'length', isImperial) : ' - '}
      </ListItemComponent>
      <ListItemComponent title={t('Qualita')}>
        {statSingulation ? `${statSingulation} %` : ' - '}
      </ListItemComponent>
      <ListItemComponent title={t('SemiDoppi')}>
        {statDoubles ? `${statDoubles} %` : ' - '}
      </ListItemComponent>
      <ListItemComponent title={t('SemiMancanti')}>
        {statSkips ? `${statSkips} %` : ' - '}
      </ListItemComponent>
      <ListItemComponent title={t('Obiettivo')}>
        {statTotalTarget ? formatValueWithUnit(statTotalTarget, 'investment', isImperial) : ' - '}
      </ListItemComponent>
    </>
  )
}